export default __webpack_public_path__ + "images/Three_Vessel_View.62e13b57d87bb87003223d5f9ece9c57.png";